// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-did-mount-set-state */

import { createElement, findDOMNode, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Translate from '../Translate';

import './Cuttable.less';

/**
 * The `Collapse` component shows and hides part of content.
 */
class Cuttable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: null,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    componentDidMount() {
        const node = findDOMNode(this).firstElementChild;
        if (node.scrollHeight > node.clientHeight) {
            this.setState({
                collapsed: this.props.collapsed,
            });
        }
    }

    handleToggle() {
        this.setState(({ collapsed }) => ({
            collapsed: !collapsed,
        }));
    }

    render() {
        const {
            baseClassName,
            className,
            children,
            collapsed,
            maxHeight,
            locale,
            ...props
        } = this.props;

        const showMoreLessKey = this.state.collapsed ? 'showMore' : 'showLess';

        return (
            <div
                className={classNames(
                    baseClassName,
                    {
                        [`${baseClassName}--collapse`]: this.state.collapsed === true,
                        [`${baseClassName}--expand`]: this.state.collapsed === false,
                    },
                    className,
                )}
                {...props}
            >
                <div className={`${baseClassName}__content`} style={{ maxHeight }}>
                    {children}
                </div>
                {this.state.collapsed !== null && (
                    <div className={`${baseClassName}__action`}>
                        <a onClick={this.handleToggle}>
                            <Translate content={`Cuttable.${showMoreLessKey}`} fallback={locale[showMoreLessKey]} />
                        </a>
                    </div>
                )}
            </div>
        );
    }
}
Cuttable.propTypes = {
    /**
     * Content of the component.
     */
    children: PropTypes.node,
    /**
     * Whether the component is open or closed.
     */
    collapsed: PropTypes.bool,
    /**
     * Max height of content
     */
    maxHeight: PropTypes.string,
    /**
     * Localization messages
     */
    locale: PropTypes.shape({
        showMore: PropTypes.any,
        showLess: PropTypes.any,
    }),
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Cuttable.defaultProps = {
    children: null,
    collapsed: true,
    maxHeight: '7rem',
    locale: {
        showMore: 'Show more',
        showLess: 'Show less',
    },
    className: null,
    baseClassName: `${CLS_PREFIX}cuttable`,
};

export default Cuttable;



// WEBPACK FOOTER //
// ./components/Cuttable/Cuttable.js